import React from "react";
import { Box, Stack, Typography, Paper, Divider, Chip } from "@mui/material";
import { Numbers } from "@mui/icons-material"; // o tu icon
import TextBox from "../TextBox";
// Asumo que tu TextBox soporta: label, icon, name, onChange, newValue, helperText, externalError, externalHelperText, InputProps, sx

export default function AdjustmentBox({
  value,
  onChange,
  computedTotalCents,
  adjustedTotalCents,
  outOfRange,
  formatCurrency,
}) {
  const base = formatCurrency((computedTotalCents || 0) / 100);
  const total = formatCurrency((adjustedTotalCents || 0) / 100);

  return (
    <Paper
      variant="outlined"
      sx={{
        mt: 1,
        mb: 1,
        p: 1.25,
        borderRadius: 2,
        bgcolor: "background.paper",
        borderColor: outOfRange ? "error.light" : "divider",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.25}
        alignItems={{ xs: "stretch", sm: "center" }}
        justifyContent="space-between"
      >
        {/* Left: resumen compacto */}
        <Box sx={{ minWidth: 220 }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.25 }}>
            <Chip
              size="small"
              label="Ajuste de decimales"
              sx={{
                borderRadius: 1.5,
                fontWeight: 700,
                bgcolor: "action.hover",
              }}
            />
            <Typography variant="caption" color="text.secondary">
              Base {base}
            </Typography>
          </Stack>

          <Typography variant="caption" color={outOfRange ? "error.main" : "text.secondary"}>
            {outOfRange ? "El ajuste no puede exceder 100.00" : `Total con ajuste: ${total}`}
          </Typography>
        </Box>

        <Divider flexItem orientation="vertical" sx={{ display: { xs: "none", sm: "block" } }} />

        {/* Right: input alineado y compacto */}
        <Box sx={{ display: "flex", justifyContent: { xs: "flex-start", sm: "flex-end" } }}>
          <Box sx={{ width: { xs: "100%", sm: 260 } }}>
            <TextBox
              label="Ajuste"
              icon={Numbers}
              type="text"
              name="invoice_adjustment"
              onChange={onChange}
              pattern="^-?\\d*(\\.\\d{0,2})?$"
              newValue={value ?? ""}
              externalError={outOfRange}
              // en vez de helperText largo dentro del TextBox, lo movimos al resumen de arriba
              helperText=""
              externalHelperText=""
              // Si tu TextBox pasa props a TextField: esto lo hace más “money-like”
              InputProps={{
                startAdornment: (
                  <Typography variant="body2" sx={{ color: "text.secondary", mr: 0.75, fontWeight: 700 }}>
                    ±
                  </Typography>
                ),
                inputProps: { inputMode: "decimal" },
              }}
              sx={{
                // Evita el look “gigante”
                "& .MuiInputBase-root": { borderRadius: 2 },
                "& input": { textAlign: "right", fontWeight: 700 },
              }}
            />
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
}
